import { CREATE_GOLF_INVENTORY, CREATE_GOLF_INVENTORY_SUCCESS, CREATE_GOLF_INVENTORY_ERROR, CREATE_GOLF_INVENTORY_EMPTY } from '../../../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const CreateGolfInventory = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_GOLF_INVENTORY:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case CREATE_GOLF_INVENTORY_SUCCESS:
      console.log('hello action', action.payload);
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case CREATE_GOLF_INVENTORY_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case CREATE_GOLF_INVENTORY_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default CreateGolfInventory;
